export default __webpack_public_path__ + "static/media/whyChooseUsIcon5.26493cc6.webp";